import React from 'react';
import * as Utils from "../../inc/Utils";
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useParams, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import {MENU_REBRANDLY, MENU_UTM_GENERATE, MENU_ADSNAMING_GENERATE, MENU_AWS_S3} from "../../inc/Utils";
import moment from "moment-timezone";
import {MENU_LEAD_FORM_PROJECT} from "../../inc/Utils";
import {MENU_LEAD_FORM_CAMPAIGN} from "../../inc/Utils";
import {MENU_SHORTIO} from "../../inc/Utils";
import {MENU_AWS_S3_EXPORT} from "../../inc/Utils";

export default function PermissionEdit() {
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let permissionId = decode.id;

    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'อัพเดตข้อมูล';
    let btnTextLoading = 'กำลังอัพเดต..';
    let [isLoading, setLoading] = React.useState(false);
    let [data, setData] = React.useState('');
    let [menu, setMenu] = React.useState('');
    let [statusChecked, setStatusChecked] = React.useState(false);
    const navigate = useNavigate();

    let refName = React.useRef();

    React.useEffect(() => {
        (async function() {
            try {
                const resMenu = await getMenuGroup();
                setMenu(resMenu);
                const resView = await getView();
                setData(resView);
                setStatusChecked(resView.status===1);
                refName.current.value = resView.name;
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getMenuGroup() {
        const response = await fetch(Config.url.API_URL +'/api/menuGroup/listing', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getView() {
        const response = await fetch(Config.url.API_URL +'/api/permission/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: permissionId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onUpdate = () => {
        let items = [];
        if(menu.length > 0) {
            for(let rs of menu) {
                if(rs.items.length > 0) {
                    for(let item of rs.items) {
                        let itemViewCheckBox = document.getElementsByName('itemView['+item.id+']');
                        let itemCreateCheckBox = document.getElementsByName('itemCreate['+item.id+']');
                        let itemEditCheckBox = document.getElementsByName('itemEdit['+item.id+']');
                        let itemDeleteCheckBox = document.getElementsByName('itemDelete['+item.id+']');
                        let itemShortLinkCheckBox = document.getElementsByName('itemShortLink['+item.id+']');
                        if(itemViewCheckBox[0].checked || itemCreateCheckBox[0].checked || itemEditCheckBox[0].checked || itemDeleteCheckBox[0].checked || itemShortLinkCheckBox[0].checked) {
                            items.push({
                                'menuId': item.id,
                                'isView': itemViewCheckBox[0].checked ? 1:0,
                                'isCreate': itemCreateCheckBox[0].checked ? 1:0,
                                'isEdit': itemEditCheckBox[0].checked ? 1:0,
                                'isDelete': itemDeleteCheckBox[0].checked ? 1:0,
                                'isShortLink': itemShortLinkCheckBox[0].checked ? 1:0,
                            });

                        }
                    }
                }
            }
        }

        let name = refName.current.value;
        if(!name) {
            toast.error("กรุณาระบุ ชื่อ Permission");
            refName.current.focus();
        }
        else if(items.length <= 0) {
            toast.error("กรุณากำหนด สิทธิ์การใช้งาน อย่างน้อย 1 รายการ");
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการอัพเดตข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            const body = {
                                id: data.id,
                                name: name,
                                currentName: data.name,
                                status: statusChecked[0].checked ? 1:0,
                                updatedBy: userId,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                items: items
                            };
                            fetch(Config.url.API_URL +'/api/permission/update', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("อัพเดตข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/permission', {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    let itemCheckedView = false;
    let itemCheckedCreate = false;
    let itemCheckedEdit = false;
    let itemCheckedDelete = false;
    let itemCheckedShortLink = false;

    if(data) {
        let isViews = [];
        let isCreates = [];
        let isEdits = [];
        let isDeletes = [];
        let isShortLinks = [];
        if(data.items) {
            for(let item of data.items) {
                if(item.isView) {
                    isViews.push(item.menuId);
                }
                if(item.isCreate) {
                    isCreates.push(item.menuId);
                }
                if(item.isEdit) {
                    isEdits.push(item.menuId);
                }
                if(item.isDelete) {
                    isDeletes.push(item.menuId);
                }
                if(item.isShortLink) {
                    isShortLinks.push(item.menuId);
                }
            }
        }

        if(menu) {
            for(let ow of menu) {
                if(ow.items) {
                    for(let it of ow.items) {
                        it.isView = isViews.includes(it.id);
                        it.isCreate = isCreates.includes(it.id);
                        it.isEdit = isEdits.includes(it.id);
                        it.isDelete = isDeletes.includes(it.id);
                        it.isShortLink = isShortLinks.includes(it.id);
                    }
                }
            }
        }
    }

    const onCheckAll = (isChecked, menuId) => {
        let chkView = 'itemView[' + menuId + ']';
        if(document.getElementsByName(chkView)) {
            document.getElementsByName(chkView)[0].checked = isChecked;
        }
        let chkCreate = 'itemCreate[' + menuId + ']';
        if(document.getElementsByName(chkCreate)) {
            document.getElementsByName(chkCreate)[0].checked = isChecked;
        }
        let chkEdit = 'itemEdit[' + menuId + ']';
        if(document.getElementsByName(chkEdit)) {
            document.getElementsByName(chkEdit)[0].checked = isChecked;
        }
        let chkDelete = 'itemDelete[' + menuId + ']';
        if(document.getElementsByName(chkDelete)) {
            document.getElementsByName(chkDelete)[0].checked = isChecked;
        }
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Permission</div>
                    <span className="ms-1">/</span> <span className="text-muted">Edit</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="name" className="form-label">ชื่อ Permission <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="name" ref={refName} maxLength={100} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="menux" className="form-label">สิทธิ์การใช้งาน <span className="text-danger">*</span></label>
                                {
                                    menu.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                                    menu.map((row, index) => {
                                                return (
                                                    <div key={index} className="d-block mb-3">
                                                        <span className="fw-bold d-block">{row.name}</span>
                                                        <div className="d-block ms-2">
                                                        {
                                                            row.items.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                                                                row.items.map((item, index2) => {
                                                                    let menuId = item.id;
                                                                    let chkAll = 'chkAll' + item.id;
                                                                    let chkView = 'chkView' + item.id;
                                                                    let chkCreate = 'chkCreate' + item.id;
                                                                    let chkEdit = 'chkEdit' + item.id;
                                                                    let chkDelete = 'chkDelete' + item.id;
                                                                    let chkShortLink = 'chkShortLink' + item.id;
                                                                    let itemView = 'itemView['+menuId+']';
                                                                    let itemCreate = 'itemCreate['+menuId+']';
                                                                    let itemEdit = 'itemEdit['+menuId+']';
                                                                    let itemDelete = 'itemDelete['+menuId+']';
                                                                    let itemShortLink = 'itemShortLink['+menuId+']';
                                                                    return (
                                                                        <div key={index2}>
                                                                            <span className="d-block mt-2 mb-1">{item.name}</span>

                                                                            <div className="form-check form-check-inline ms-2">
                                                                                <input className="form-check-input"   type="checkbox" id={chkAll} onChange={e => {onCheckAll(e.target.checked, menuId)}} />
                                                                                <label className="form-check-label small" htmlFor={chkAll}>All</label>
                                                                            </div>

                                                                            <div className="form-check form-check-inline ms-2">
                                                                                <input className="form-check-input" name={itemView} type="checkbox" id={chkView} defaultChecked={item.isView} onClick={e => {itemCheckedView = e.target.checked;}} />
                                                                                <label className="form-check-label small" htmlFor={chkView}>
                                                                                    View
                                                                                </label>
                                                                            </div>
                                                                            <div className={"form-check form-check-inline ms-2" + (menuId === MENU_REBRANDLY || menuId === MENU_AWS_S3 || menuId === MENU_SHORTIO || menuId === MENU_AWS_S3_EXPORT ? ' d-none':'')}>
                                                                                <input className="form-check-input" name={itemCreate} type="checkbox" id={chkCreate} defaultChecked={item.isCreate} onClick={e => {itemCheckedCreate = e.target.checked;}} />
                                                                                <label className="form-check-label small" htmlFor={chkCreate}>
                                                                                    Create
                                                                                </label>
                                                                            </div>
                                                                            <div className={"form-check form-check-inline ms-2" + (menuId === MENU_UTM_GENERATE || menuId === MENU_ADSNAMING_GENERATE || menuId === MENU_LEAD_FORM_PROJECT || menuId === MENU_LEAD_FORM_CAMPAIGN ? ' d-none':'')}>
                                                                                <input className="form-check-input" name={itemEdit} type="checkbox" id={chkEdit} defaultChecked={item.isEdit} onClick={e => {itemCheckedEdit = e.target.checked;}} />
                                                                                <label className="form-check-label small" htmlFor={chkEdit}>
                                                                                    Edit
                                                                                </label>
                                                                            </div>
                                                                            <div className={"form-check form-check-inline ms-2" + (menuId === MENU_REBRANDLY || menuId === MENU_AWS_S3 || menuId === MENU_SHORTIO || menuId === MENU_AWS_S3_EXPORT ? ' d-none':'')}>
                                                                                <input className="form-check-input" name={itemDelete} type="checkbox" id={chkDelete} defaultChecked={item.isDelete} onClick={e => {itemCheckedDelete = e.target.checked;}} />
                                                                                <label className="form-check-label small" htmlFor={chkDelete}>
                                                                                    Delete
                                                                                </label>
                                                                            </div>
                                                                            <div className={"form-check form-check-inline ms-2" + (menuId === MENU_UTM_GENERATE ? '':' d-none')}>
                                                                                <input className="form-check-input" name={itemShortLink} type="checkbox" id={chkDelete} defaultChecked={item.isShortLink} onClick={e => {itemCheckedShortLink = e.target.checked;}} />
                                                                                <label className="form-check-label small" htmlFor={chkShortLink}>
                                                                                    Create ShortLink
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })
                                                        }
                                                        </div>
                                                    </div>
                                                );
                                    })
                                }
                            </div>
                            <div className="col-12">
                                <label htmlFor="statusx" className="form-label">สถานะ</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" checked={statusChecked} onChange={e => {setStatusChecked(e.target.checked)}} />
                                    <label className="form-check-label" htmlFor="status"></label>
                                </div>
                            </div>
                            <div className="col-12">
                                <button type="button" className="btn btn-primary" onClick={onUpdate}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                <NavLink className="btn btn-sm btn-light ms-2" to='/permission'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 